var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRandom10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ad5cad;}.b{fill:#5a9daf;}.c{fill:#aa5f5d;}.d{fill:#e9893a;}.e{fill:#fbc933;}.f{fill:#c1b5d2;}.g{fill:#95b633;}.h{fill:#fff;font-size:3px;font-family:SegoeUI, Segoe UI;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 -502)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 502)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 12,
    transform: "translate(0 38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 13,
    height: 13,
    transform: "translate(0 25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 13,
    height: 12,
    transform: "translate(0 13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 37,
    height: 25,
    transform: "translate(13)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 12,
    height: 13,
    transform: "translate(38 25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 25,
    height: 13,
    transform: "translate(13 25)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(29 516)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini oudoing")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(23 547)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini oudoing")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(30 535)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(12 535)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(12 522)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(12 510)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "h",
    transform: "translate(50 535)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandom10);
export default __webpack_public_path__ + "static/media/random10.35c2ae409ffa53267207669ed4e527bb.svg";
export { ForwardRef as ReactComponent };